/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig, { colors } from '@/../themeConfig.js'

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : 'John Doe', // From Auth
  about       : 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
  photoURL    : require('@/assets/images/portrait/small/avatar-s-11.jpg'), // From Auth
  status      : 'online',
  userRole    : 'admin'
}

const userInfoLocalStorage = JSON.parse(localStorage.getItem('userInfo')) || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
  const userInfo = {}

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
  })

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if (userInfo[key] === undefined && userInfoLocalStorage[key] !== null) userInfo[key] = userInfoLocalStorage[key]
  })

  return userInfo
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if ('ontouchstart' in window || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const webSocketFunction = (base_self, entityName) => {
  const nameUpperCase = `${entityName.charAt(0).toUpperCase()}${entityName.slice(1)}`
  const chatSocket = window.createConnection(`${localStorage.getItem('esm_ws_ip')}${nameUpperCase}/`)
  chatSocket.onmessage = function (e) {
    const data = JSON.parse(e.data)

    console.log('data: ', data)

    let trouver = false


    const length = base_self[`${entityName}s`].length
    for (let i = 0; i < length; i++) {
      const item = base_self[`${entityName}s`][i]
      if (item.id === data['instance'].id) {
        if (data['instance'].state) {
          base_self[`${entityName}s`][i] = data['instance']
          base_self[`${entityName}s`] = JSON.parse(JSON.stringify(base_self[`${entityName}s`]))
        } else {
          base_self[`${entityName}s`].splice(i, 1)
        }

        trouver = true
        break
      }
    }

    if (data['created'] && !trouver) {
      base_self[`${entityName}s`].unshift(data['instance'])
    }
  }
  chatSocket.onclose = function (e) { console.error('Chat socket closed unexpectedly', e) }
}

const convertDateTime = (dateTimeSysteme) => {
  const getFullYear = dateTimeSysteme.getFullYear()

  const getMonth = (`0${dateTimeSysteme.getMonth() + 1}`).slice(-2)
  const getDate = (`0${dateTimeSysteme.getDate()}`).slice(-2)

  const getHours = (`0${dateTimeSysteme.getHours()}`).slice(-2)
  const getMinutes = (`0${dateTimeSysteme.getMinutes()}`).slice(-2)
  const getSeconds = (`0${dateTimeSysteme.getSeconds()}`).slice(-2)


  const date = `${getFullYear}-${getMonth}-${getDate}`
  const time = `${getHours}:${getMinutes}:${getSeconds}`
  const dateTime = `${date} ${time}`

  return { dateTime, date, time }
}

const paramInscription = {
  is_get: true,
  paginate: {
    length: 20,
    page: 1
  },
  filter: {
    q_list: [],
    abandon: false,
    anneeScolaire__cloture: false,
    anneeScolaire__encours: true
  },
  orderby: ['eleve__full_name'],
  juste: {
    abandonAtente: '',
    id: '',
    eleve: {
      id: '',
      photo: { url: '' },
      matricule: '',
      full_name: '',
      dateEntree: '',
      naissance: '',
      sexe: {
        code: ''
      }
    },
    statutEleve: {
      id: '',
      libelle: ''
    },
    salle: {
      id: '',
      libelle: ''
    }
  }
}

const paramBulletin = {
  is_get: true,
  paginate: {
    length: 150,
    page: 1
  },
  filter: {
    q_list: []
  },
  orderby: ['-moyenne', 'rang'],
  juste: {
    id: '',
    partitionInscription: {
      id: '',
      inscription: {
        id: '',
        eleve: {
          matricule: '',
          full_name: '',
          sexe: {
            code: ''
          }
        }
      }
    },
    nombreAbsence: '',
    nombreRetard: '',
    moyenne: '',
    rang: ''
  }
}

const paramExamen = {
  is_get: true,
  paginate: {
    length: 5,
    page: 1
  },
  filter: {
    partition__niveauTypePartition__anneeScolaire__cloture: false,
    partition__niveauTypePartition__anneeScolaire__encours: true,
    q_list: []
  },
  juste: {
    id: '',
    dateEvaluation: '',
    heureDebut: '',
    heureFin: '',
    nonEffectuer: '',
    partition: {
      id: '',
      long_label: ''
    },
    professeurClasseMatiere: { 
      id: '',
      libelle: '',
      salle: {
        id: '',
        libelle: '',
        classe: {
          id: '',
          niveau: {
            id: ''
          }
        }
      },
      classeMatiere: {
        id: '',
        matiere: {
          libelle: ''
        }
      }
    },
    typeExamen: { 
      id: '',
      libelle: ''
    }
  }
}

const paramNotes = {
  is_get: true,
  paginate: {
    length: 150,
    page: 1
  },
  filter: {
    q_list: []
  },
  juste: {
    id: '',
    inscription: {
      id: '',
      eleve: {
        matricule: '',
        full_name: ''
      }
    },
    valeur: ''
  }
}

const paramDispenserDUneMatiere = {
  is_get: true,
  paginate: {
    length: 150,
    page: 1
  },
  filter: {
    q_list: []
  }
}

const paramPartitionInscription = {
  is_get: true,
  paginate: {
    length: 150,
    page: 1
  },
  filter: {
    q_list: []
  },
  orderby: ['inscription__eleve__full_name']
}

const paramClasseMatiere = {
  is_get: true,
  paginate: {
    length: 150,
    page: 1
  },
  filter: {
    q_list: [],
    classe__is_active: true,
    classe__niveau__is_active: true
  }
}

const paramProfesseurClasseMatiere = {
  is_get: true,
  paginate: {
    length: 150,
    page: 1
  },
  filter: {
    q_list: [],
    classeMatiere__anneeScolaire__encours: true,
    classeMatiere__anneeScolaire__cloture: false
  }
}

const paramProfesseurTitulaire = {
  is_get: true,
  paginate: {
    length: 150,
    page: 1
  },
  filter: {
    q_list: []
  }
}

const paramPresence = {
  is_get: true,
  paginate: {
    length: 150,
    page: 1
  },
  filter: {
    q_list: []
  }
}

const getSimple = async (base_self, libelle, data) => {
  return new Promise((resolve) => {
    base_self.$http.post(libelle, data)
      .then((response) => {
        base_self.sexes = response.data.data
        resolve(response)
      })
      .catch((error) => {
        resolve(false)
        console.log('error: ', error)
      })
  })
}

const state = {
  ecole: {
    lidao: false,
    laCraie: false,
    monParcours: false
  },
  // Easy Management School
  itemsPerPages: [5, 10, 20, 50, 100, 150, 200, 500],
  anneeScolaire: {},
  paramInscription,
  paramBulletin,
  paramProfesseurClasseMatiere,
  paramClasseMatiere,
  paramPartitionInscription,
  paramProfesseurTitulaire,
  paramNotes,
  paramDispenserDUneMatiere,
  paramExamen,
  paramPresence,
  getSimple,
  webSocketFunction,
  convertDateTime,
  route_for_account       : 'auth/account/',
  route_for_esm           : 'base/',

  // Easy Management School

  AppActiveUser           : getUserInfo(),
  bodyOverlay             : false,
  isVerticalNavMenuActive : true,
  is_touch_device         : is_touch_device(),
  mainLayoutType          : themeConfig.mainLayoutType || 'vertical',
  navbarSearchAndPinList,
  reduceButton            : themeConfig.sidebarCollapsed,
  verticalNavMenuWidth    : 'default',
  verticalNavMenuItemsMin : false,
  scrollY                 : 0,
  starredPages            : navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
  theme                   : themeConfig.theme || 'light',
  themePrimaryColor       : colors.primary,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null
}

export default state
